import request from '@/router/axios';

// 获取项目列表
export const getProjectList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/connection/diagram/getAllProjects',
    method: 'get',
    params: {
      ...data
    }
  })
}
// 添加项目
export const addProject = (data) => {
  return request({
    url: '/Project/addProject',
    method: 'POST',
    data: data
  })
}
//获取导航窗口列表
export const getNavigationList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/connection/diagram/getNavigationList',
    method: 'GET',
    data: data
  })
}
//检索项目设备
export const getProjectFieldsByEs = (data) => {
  return request({
    url: '/svolt-ess-boss-service/project/getProjectFieldsByEs',
    method: 'post',
    data: data
  })
}
export default {
  getProjectList,
  addProject,
  getNavigationList,
  getProjectFieldsByEs
}



// WEBPACK FOOTER //
// ./src/views/design/api/project.js